import axios from "axios";

export const traceBatchHistory = (transactionNumbers: string[]) =>
  axios
    .post("materialTraceabilityHistory", {
      transactionNumbers,
    })
    .then((res) => res.data);

export default traceBatchHistory;
